export function exportToCSV(fileName, fieldSeparator, dataToExport) {
    if (dataToExport?.length > 0) {
        let csvContent = 'data:text/csv;charset=utf-8,';
        const headers = Object.keys(dataToExport[0]).join(
            fieldSeparator
        );
        const content = dataToExport.map((item) =>
            Object.values(item).join(fieldSeparator)
        );
        csvContent += [headers, ...content]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');
        const data = encodeURI(csvContent);
        const link = document.createElement('a');

        link.setAttribute('href', data);
        link.setAttribute('download', fileName);
        link.click();
    }
}

export async function exportToExcel(fileName, dataToExport) {
    if (dataToExport?.length > 0) {
        const exportXlsx = await import('xlsx');
        const data = exportXlsx.utils.json_to_sheet(dataToExport);
        const workBook = exportXlsx.utils.book_new();
        exportXlsx.utils.book_append_sheet(workBook, data, 'data');
        exportXlsx.writeFile(workBook, fileName);
    }
}
